import { CommandHandelingState } from "./commandHandelingState.enum";

export class CommandAttempt {
  Id: string;
  Error: string;
  FullError: string;
  Source: string;
  State: CommandHandelingState;
  StartDate: Date;

  constructor(attempt: {
    id?: string;
    error?: string;
    fullError?: string;
    state?: CommandHandelingState;
    startDate?: Date;
    source?: string;
  }) {
    this.Id = attempt.id;
    this.Error = attempt.error;
    this.FullError = attempt.fullError;
    this.State = attempt.state;
    this.StartDate = attempt.startDate;
    this.Source = attempt.source;
  }
}
